const getters = {
  scEmployeeRoles: state => state.sc_employee_roles,
  scEmployeeRole: state => state.sc_employee_role,
  scEmployeeRoleFilters: state => state.sc_employee_role_filters,
}

export default getters;
